import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CellCoordinates } from '../../types/Spreadsheet';
import { RootState } from '../store';

interface ClipboardState {
  cutCells: CellCoordinates[];
  cutBuffer: Record<string, Record<string, any>> | null;
}

const initialState: ClipboardState = {
  cutCells: [],
  cutBuffer: null
};

const clipboardSlice = createSlice({
  name: 'clipboard',
  initialState,
  reducers: {
    setCutCells( state, action: PayloadAction<CellCoordinates[]> ) {
      state.cutCells = action.payload;
    },
    setCutBuffer( state, action: PayloadAction<Record<string, Record<string, any>> | null> ) {
      state.cutBuffer = action.payload;
    },
    clearCut( state ) {
      state.cutCells = [];
      state.cutBuffer = null;
    }
  }
});

export const { setCutCells, setCutBuffer, clearCut } = clipboardSlice.actions;

export default clipboardSlice.reducer;

// Selectors
export const selectCutCells = ( state: RootState ) => state.spreadsheet.clipboard.cutCells;
export const selectCutBuffer = ( state: RootState ) => state.spreadsheet.clipboard.cutBuffer;

